export const enUS = {
  language: 'en_US',
  translation: {
    APP: 'ROI',
    TITLE:
      'Deep Learning Database for Water Management and Cultivation Project',
    SUB_TITLE: 'Water Allocation Branch 1',
    MENU: {
      DRY_SEASON: 'Water Allocation',
      COMMON: 'Basic information',
      SETTING: 'Settings',
    },
    POPUP: {
      SAVE: {
        TITLE: 'Save',
        MESSAGE: 'Do you want to save the data?',
      },
      EDIT: {
        TITLE: 'Edit',
        MESSAGE: 'Do you want to edit the data?',
      },
      REMOVE: {
        TITLE: 'Remove',
        MESSAGE: 'Do you want to remove the data?',
      },
      ERROR: {
        TITLE: 'An error occurred.',
      },
      COMPLETE: 'Complete',
      SAVE_ROS_GIS: {
        TITLE: 'บันทึก',
        MESSAGE:
          'You have not uploaded an attachment ROS and GIS. Do you want to save anyway ?',
      },
      SAVE_ROS: {
        TITLE: 'บันทึก',
        MESSAGE:
          'You have not uploaded an attachment ROS. Do you want to save anyway ?',
      },
      SAVE_GIS: {
        TITLE: 'บันทึก',
        MESSAGE:
          'You have not uploaded an attachment GIS. Do you want to save anyway ?',
      },
      NOTIFICATION: {
        TITLE: 'Notifications',
        MESSAGE: 'No data',
        BUTTON: 'See all notifications',
      },
      CONVERSATION: {
        TITLE: 'Conversation',
      },
      BUTTON: {
        SEARCH: 'Search',
        CLOSE: 'Close',
        SAVE: 'Save',
        EDIT: 'Edit',
        CANCEL: 'Cancel',
        OK: 'Ok',
      },
    },
    SELECT: {
      VALUE: {
        PLEASE_SELECT: 'Select your option',
        ALL: 'All',
      },
      YEAR: {
        LABEL: 'Year',
        PLACEHOLDER: 'Select your option',
      },
      PROVINCE: {
        LABEL: 'Province',
        PLACEHOLDER: 'Select your option',
      },
      IRRIGATION_DEPARTMENT: {
        LABEL: 'Irrigation',
        PLACEHOLDER: 'Select your option',
      },
      PROJECT: {
        LABEL: 'Project',
        PLACEHOLDER: 'Select your option',
      },
      RESERVOIR: {
        LABEL: 'Reservoir',
        PLACEHOLDER: 'Select your option',
      },
      STATUS: {
        LABEL: 'Status',
        PLACEHOLDER: 'Select your option',
      },
      NATURAL_WATER: {
        LABEL: 'Natural water source',
        PLACEHOLDER: 'Select your option',
      },
      APPROVE_TYPE: {
        LABEL: 'Approve Type',
        PLACEHOLDER: 'Select your option',
      },
      OTHER_MEDIUM_RESERVOIR: {
        LABEL: 'Other Medium Reservoir',
        PLACEHOLDER: 'Select your option',
      },
      WATER_SOURCE: {
        LABEL: 'Water Source',
        PLACEHOLDER: 'Select your option',
      },
    },
    STATUS: {
      WATER_ALLOCATED: ' Water Allocated',
      PENDING: 'Pending',
      WAIT_APPROVE: 'Pending Approval',
      NO_ALLOCATION: 'No Allocation',
      IS_DEPARTMENT_CHANGED: 'Update by department',
      LABEL: {
        PROJECT: 'Project',
      },
    },
    BUTTON: {
      SEARCH: 'Search',
      ADD: 'Add',
      CLOSE: 'Close',
      FILE: 'Download attachment',
      DOWNLOAD: 'Download',
      ROS_FILE: 'Attachment ROS',
      GIS_FILE: 'Attachment GIS',
      CONFIRM: 'Confirm',
      MONTHLY: 'Monthly Water Demand',
      ADD_DAILY: 'Create Daily Plan',
      ADD_WEEKLY: 'Create Weekly Plan',
      ADD_PROJECT: 'Create Project',
      SELECT_FILE: 'Select File',
      DOWNLOAD_TEMP: 'Download Template',
      IMPORT_DAILY: 'Import Daily Plan',
      SHOW_FLOW: 'Show Diagram',
      GUIDE: 'Guide',
      CHANGE_PASSWORD: 'Chage Password',
      LANGUAGE: 'Language',
      SIGN_OUT: 'Sign out',
      REPLY: 'Reply',
    },
    TABLE: {
      HEADER: {
        SEQUENCE: 'Sequence',
        YEAR: 'Year',
        RESERVOIR: 'Reservoir',
        IRRIGATION_DEPARTMENT: 'Irrigation',
        PROJECTS: 'Project',
        PROVINCE: 'Province',
        AREA: 'Area (Rai)',
        WATER_VOLUME_1NOV: 'Water Volume as of 1 Nov',
        FORECASTED: 'Forecast of Available Base Water',
        CURRENT_WATER: 'Current Water Volume',
        WATER_VOLUME: 'Water Volume (MCM)',
        AREA_IRRIGATION: 'Area of irrigation',
        AREA_CULTIVATION: 'Area of Cultivation (Rai)',
        WATER_PERIOD: 'Water Delivery Period',
        TOTAL: 'Total',
        START_DATE: 'Start',
        END_DATE: 'End',
        RESERVOIR_OTHER: 'Reservoirs / Other water sources',
        MENU: 'Menu',
        STATUS: 'Status',
        FILE: 'Attachment',
        APPROVE_TYPE: 'Approve Type',
        REMARK: 'Remark',
        MANAGE: 'Manage',
        UPDATE_DATE: 'Update Date',
        DATE: 'Date',
        WEEK_NO: 'Week No',
        PERIOD: 'Period',
        TOTAL_MCM: 'Total (MCM)',
        LARGE_RESERVOIR_DAILY:
          'Daily Water Allocation Plan for Large Reservoirs (MCM)',
        LARGE_RESERVOIR_WEEKLY:
          'Weekly Water Allocation Plan for Large Reservoirs (MCM)',
        MEDIUM_RESERVOIR_DAILY:
          'Daily Water Allocation Plan for Medium Reservoirs (MCM)',
        MEDIUM_RESERVOIR_WEEKLY:
          'Weekly Water Allocation Plan for Medium Reservoirs (MCM)',
        MONTHLY_DEMAND: ' Monthly Water Demand (MCM)',
        MONTH_YEAR: 'Month / Year',
        WATER_SOURCE: 'Water Source',
      },
    },
    INPUT: {
      START_DATE: {
        LABEL: 'Start Date',
        PLACEHOLDER: 'Start Date',
        VALIDATE: {
          REQUIRED: 'This field is required.',
        },
      },
      END_DATE: {
        LABEL: 'End Date',
        PLACEHOLDER: 'End Date',
        VALIDATE: {
          REQUIRED: 'This field is required.',
        },
      },
      WATER_VOLUME_1NOV: {
        LABEL: 'Water Volume as of 1 Nov',
        PLACEHOLDER: '',
        VALIDATE: {
          REQUIRED: 'This field is required.',
        },
      },
      CURRENT_WATER: {
        LABEL: 'Current Water Volume',
        PLACEHOLDER: '',
        VALIDATE: {
          REQUIRED: 'This field is required.',
        },
      },
      FORECASTED: {
        LABEL: 'Forecast of Available Base Water (MCM)',
        PLACEHOLDER: 'Forecast of Available Base Water',
        VALIDATE: {
          REQUIRED: 'This field is required.',
          MAX: 'Forecast of Available Base Water',
        },
      },
      REMARK: {
        LABEL: 'Remark',
        PLACEHOLDER: 'Please enter a reason for rejection.',
        VALIDATE: {
          REQUIRED: 'This field is required.',
        },
      },
      COMMENT: {
        LABEL: 'Comment',
        PLACEHOLDER:
          'Comment required if allocated volume exceeds forecasted base water volume.',
        VALIDATE: {
          REQUIRED:
            'Please enter a comment explaining that the water volume exceeds the forecasted base water volume.',
        },
      },
      ROS: {
        LABEL: 'ROS FIle',
      },
      GIS: {
        LABEL: 'GIS FIle',
      },
      WATER_SOURCE: {
        LABEL: 'Water Source',
        PLACEHOLDER: 'Water Source Name',
      },
      CONVERSATION: {
        LABEL: '',
        PLACEHOLDER: 'New Message',
      },
    },

    FILE_NAME: {
      TEMPLATE_DAILY: 'Template_Daily_Water_Plan',
      PLAN_DAILY: 'Daily_Water_Plan',
      WEEKLY_DAILY: 'Weekly_Water_Plan',
    },
    PAGE: {
      DASHBOARD: {
        TOTAL: {
          WATER: 'Total water volume',
          LAND: 'Total forecasted area',
        },
        TABLE: {
          TOTAL: 'Total',
          DAM: 'Dam',
        },
        TAB: {
          NATIONWIDE: {
            NAME: 'Nationwide water allocation',
            TITLE_WATER: 'Water allocation plan (MCM)',
            TITLE_LAND: 'Cultivation plan or planting plan (Rai)',
          },
          RIVERBASIN: {
            NAME: 'Water allocation by river basin',
            TITLE_WATER: 'Water allocation plan (MCM)',
            TITLE_LAND: 'Cultivation plan or planting plan',
            RAI: 'Rai',
            MCM: 'MCM',
            TITLE_POPUP:
              'Water Allocation and Cultivation Plan for the River Basin',
            REMARK: 'Remark : Water Allocation Plan from Large Reservoirs',
          },
          NATURAL_WATER: {
            NAME: 'Water allocation by natural water source',
          },
        },
        CHART: {
          NO_DATA: 'No Data',
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'Select your option',
            ALL: 'All',
          },
          YEAR: {
            LABEL: 'Year',
            PLACEHOLDER: 'Select your option',
          },
          PROVINCE: {
            LABEL: 'Province',
            PLACEHOLDER: 'Select your option',
          },
          IRRIGATION_DEPARTMENT: {
            LABEL: 'Irrigation',
            PLACEHOLDER: 'Select your option',
          },
          PROJECT: {
            LABEL: 'Project',
            PLACEHOLDER: 'Select your option',
          },
          NATURAL_WATER: {
            LABEL: 'Natural water source',
            PLACEHOLDER: 'Select your option',
          },
        },
      },
      RESERVOIR: {
        TITLE: 'Reservoir',
        NAV: {
          RESERVOIR_LARGE_SIZE: 'Reservoir Large Size',
          RESERVOIR_MIDDLE_SIZE: 'Reservoir Middle Size',
          WATER_VOLUME_1NOV: 'Update Water Volume as of 1 Nov',
        },
        TABLE: {
          HEADER: {
            SEQUENCE: 'Sequence',
            RESERVOIR: 'Reservoir',
            RESPONSIBLE_PROJECTS: 'Responsible Projects',
            IRRIGATION_DEPARTMENT: 'Irrigation Department',
            PROVINCE: 'Province',
            CAPACITY_LEVEL: 'Capacity Level',
            CAPACITY_WATER: 'Capacity Water',
            WATER_LEVEL: 'Water Level',
            UNIT_01: 'MPL',
            UNIT_02: 'NPL',
            UNIT_03: 'BPL',
            MAIN_BASIN: 'Main Basin',
            SUB_BASIN: 'Sub Basin',
            RESERVOIR_TYPE: 'Reservoir Type',
            WATER_VOLUME: 'Water Volume',
            DATE_SYNC: 'Update Date',
            TOTAL: 'Total {{value}} MCM.',
            MANAGE: 'Manage',
          },
          INPUT: {
            RESERVOIR_NAME: {
              LABEL: 'Reservoir Name',
            },
          },
        },
        MANAGE: {
          HEADER: {
            ADD_RESERVOIR: 'Add Reservoir',
            EDIT_RESERVOIR: 'Edit Reservoir',
            EDIT_LIMIT: 'Water Availability Forecast',
            UPDATE_WATER_VOLUME: 'Update Water Volume',
          },
          LABEL: {
            CAPACITY_WATER: 'Capacity Water',
            CAPACITY_LEVEL: 'Capacity Level',
            WATER_LEVEL: 'Water Level',
            RESERVOIR_LARGE_SIZE: 'Reservoir Large Size (MCM)',
            RESERVOIR_MIDDLE_SIZE: 'Reservoir Middle Size (MCM)',
          },
          PLACEHOLDER: {
            RESERVOIR_LARGE_SIZE:
              'Water Availability Forecast Reservoir Large Size',
            RESERVOIR_MIDDLE_SIZE:
              'Water Availability Forecast Reservoir Middle Size (MCM)',
          },
        },
        INPUT: {
          RESERVOIR_NAME: {
            LABEL: 'Reservoir',
            PLACEHOLDER: 'Reservoir',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          UNIT_01: {
            LABEL: 'Water High',
            PLACEHOLDER: 'Water High',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          UNIT_02: {
            LABEL: 'Water Normal',
            PLACEHOLDER: 'Water Normal',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          UNIT_03: {
            LABEL: 'Water Low',
            PLACEHOLDER: 'Water Low',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },

          LATITUDE: {
            LABEL: 'Latitude',
            PLACEHOLDER: 'Latitude',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          LONGITUDE: {
            LABEL: 'Longitude',
            PLACEHOLDER: 'Longitude',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'Select your option',
            ALL: 'All',
          },
          IRRIGATION_DEPARTMENT: {
            LABEL: 'Responsible Projects',
            PLACEHOLDER: 'Responsible Projects',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },

          PROJECT: {
            LABEL: 'Project',
            PLACEHOLDER: 'Project',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          RESERVOIR: {
            LABEL: 'Reservoir',
            PLACEHOLDER: 'Reservoir',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          SHOW_ENTRY: {
            LABEL: 'Show Entry',
            PLACEHOLDER: 'Show Entry',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          RESERVOIR_SIZE: {
            LABEL: 'Reservoir Size',
            PLACEHOLDER: 'Reservoir Size',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          PROVINCE: {
            LABEL: 'Province',
            PLACEHOLDER: 'Province',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          DISTRICT: {
            LABEL: 'District',
            PLACEHOLDER: 'District',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          SUB_DISTRICT: {
            LABEL: 'Sub District',
            PLACEHOLDER: 'Sub District',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          MAIN_BASIN: {
            LABEL: 'Main Basin',
            PLACEHOLDER: 'Main Basin',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          SUB_BASIN: {
            LABEL: 'Sub Basin',
            PLACEHOLDER: 'Sub Basin',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          RESERVOIR_TYPE: {
            LABEL: 'Reservoir Type',
            PLACEHOLDER: 'type of reservoir',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
            VALUE: {
              MAJOR: 'Large Reservoir',
              MEDIUM: 'Medium Reservoir',
            },
          },
        },
        POPUP: {
          SAVE: {
            TITLE: 'Confirm',
            MESSAGE: 'Do you want to update the water volume ?',
          },
        },
        BUTTON: {
          SEARCH: 'Search',
          ADD_RESERVOIR: 'Add Reservoir',
          CLOSE: 'Close',
          SAVE: 'Save',
          EDIT: 'Edit',
          CANCEL: 'Cancel',
          OK: 'Ok',
          SYNC: 'Update Water Volume',
        },
      },
      DRY_SEASON: {
        TITLE: 'Dry Season',
        POPUP: {
          TITLE: 'Summary of dry season water allocation settings',
        },
        TABLE: {
          HEADER: {
            SEQUENCE: 'Sequence',
            YEAR: 'Year',
            DETAIL: 'Detail',
            PERIOD: 'Period',
            MANAGE: 'Manage',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'Add',
            EDIT: 'Edit',
            PERIOD: 'Period',
            SWITCH:
              'Turn off dry-season water allocation and import the allocation data to be shown on the dashboard.',
          },
        },
        INPUT: {
          YEAR: {
            LABEL: 'Year',
            PLACEHOLDER: 'Year',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          DETAIL: {
            LABEL: 'Detail',
            PLACEHOLDER: 'Detail',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          START_DATE: {
            LABEL: 'Start Date',
            PLACEHOLDER: 'Start Date',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          END_DATE: {
            LABEL: 'End Date',
            PLACEHOLDER: 'End Date',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'Select your option',
            ALL: 'All',
          },
        },

        BUTTON: {
          SEARCH: 'Search',
          ADD: 'Add',
          CLOSE: 'Close',
          SAVE: 'Save',
          EDIT: 'Edit',
          CANCEL: 'Cancel',
          OK: 'Ok',
        },
      },
      WATER_OTHER: {
        TITLE: 'Water Other',
        TABLE: {
          HEADER: {
            SEQUENCE: 'Sequence',
            FULL_NAME: ' Name',
            UPDATE_DATE: 'Update Date',
            MANAGE: 'Manage',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
          },
        },
        INPUT: {
          SEARCH: {
            LABEL: 'Search',
            PLACEHOLDER: 'Search',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          NAME: {
            LABEL: 'Name',
            PLACEHOLDER: 'Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          SHORT_NAME: {
            LABEL: 'Short Name',
            PLACEHOLDER: 'Short Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          SHOW_FULL_NAME: {
            LABEL: 'Show Full Name',
            PLACEHOLDER: 'Show Full Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          SHOW_SHORT_NAME: {
            LABEL: 'Show Short Name',
            PLACEHOLDER: 'Show Short Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'Select your option',
            ALL: 'All',
          },
          FULL_NAME: {
            LABEL: 'Full Name',
            PLACEHOLDER: 'Full Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          SHORT_NAME: {
            LABEL: 'Short Name',
            PLACEHOLDER: 'Short Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          SHOW_ENTRY: {
            LABEL: 'Show Entry',
            PLACEHOLDER: 'Show Entry',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },

        BUTTON: {
          SEARCH: 'Search',
          ADD: 'Add',
          CLOSE: 'Close',
          SAVE: 'Save',
          EDIT: 'Edit',
          CANCEL: 'Cancel',
          OK: 'Ok',
        },
      },
      PROJECT: {
        TITLE: 'Project',
        TABLE: {
          HEADER: {
            SEQUENCE: 'Sequence',
            NAME: 'Name',
            IRRIGATION_DEPARTMENT: 'Irrigation Department',
            UPDATE_DATE: 'Last Update',
            MANAGE: 'Manage',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
          },
        },
        INPUT: {
          NAME: {
            LABEL: 'Name',
            PLACEHOLDER: 'Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          DETAIL: {
            LABEL: 'Detail',
            PLACEHOLDER: 'Detail',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'Select your option',
            ALL: 'All',
          },
          IRRIGATION_DEPARTMENT: {
            LABEL: 'Irrigation Department',
            PLACEHOLDER: 'Irrigation Department',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          NAME: {
            LABEL: 'Name',
            PLACEHOLDER: 'Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          SHOW_ENTRY: {
            LABEL: 'Show Entry',
            PLACEHOLDER: 'Show Entry',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },

        BUTTON: {
          SEARCH: 'Search',
          ADD: 'Add',
          CLOSE: 'Close',
          SAVE: 'Save',
          EDIT: 'Edit',
          CANCEL: 'Cancel',
          OK: 'Ok',
        },
      },
      USER: {
        TITLE: 'User',
        TABLE: {
          HEADER: {
            SEQUENCE: 'Sequence',
            USER: 'User',
            EMAIL: 'Email',
            STATUS: 'Status',
            ROLE: 'Role',
            UPDATE_DATE: 'Last Update',
            MANAGE: 'Manage',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
            CHANGE_PASSWORD: 'Change Password',
          },

          PASSWORD: {
            CONDITION_1: 'Password must be at least 8 characters long.',
            CONDITION_2:
              'The password must contain at least one uppercase letter (A-Z)',
            CONDITION_3:
              'The password must contain at least 1 lowercase letters (a-z)',
            CONDITION_4:
              'The password must contain at least 1 numeric character [0-9]',
            CONDITION_5:
              'The password must contain at least 1 special character e.g. (!#$%&*:;?&#64;~)',
          },
        },
        INPUT: {
          NAME: {
            LABEL: 'User Name',
            PLACEHOLDER: 'User Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          EMAIL: {
            LABEL: 'Email',
            PLACEHOLDER: 'Email',
            VALIDATE: {
              REQUIRED: 'This field is required.',
              PATTERN: 'The email address is in the wrong format.',
            },
          },
          CONFIRM_PASSWORD: {
            LABEL: 'Confirm Email',
            PLACEHOLDER: 'Confirm Email',
            VALIDATE: {
              REQUIRED: 'This field is required',
              PATTERN: 'Password is inconsistent',
            },
          },
          PASSWORD: {
            LABEL: 'Password',
            PLACEHOLDER: 'Password',
            VALIDATE: {
              REQUIRED: 'This field is required',
              PATTERN: 'The password is in the wrong format',
            },
          },
          SHOW_PASSWORD: {
            LABEL: 'Show Password',
          },
          NEW_PASSWORD: {
            LABEL: 'New Password',
            PLACEHOLDER: 'New Password',
            VALIDATE: {
              REQUIRED: 'This field is required',
              PATTERN: 'The password is in the wrong format',
            },
          },
          OLD_PASSWORD: {
            LABEL: 'Old Password',
            PLACEHOLDER: 'Old Password',
            VALIDATE: {
              REQUIRED: 'This field is required',
              PATTERN: 'The password is in the wrong format',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'Select your option',
            ALL: 'All',
          },
          OFFICE: {
            LABEL: 'Irrigation Office',
            PLACEHOLDER: 'Irrigation Office',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          AFFILIATION: {
            LABEL: 'Affiliation',
            PLACEHOLDER: 'Affiliation',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          ROLE: {
            LABEL: 'Role',
            PLACEHOLDER: 'Role',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          TITLE_NAME: {
            LABEL: 'Title Name',
            PLACEHOLDER: 'Title Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          SHOW_ENTRY: {
            LABEL: 'Show Entry',
            PLACEHOLDER: 'Show Entry',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },

        BUTTON: {
          SEARCH: 'Search',
          ADD: 'Add',
          CLOSE: 'Close',
          SAVE: 'Save',
          EDIT: 'Edit',
          CANCEL: 'Cancel',
          OK: 'Ok',
        },
      },
      ROLE: {
        TITLE: 'Role',
        TABLE: {
          HEADER: {
            SEQUENCE: 'Sequence',
            NAME: 'Name',
            UPDATE_DATE: 'Last Update',
            MANAGE: 'Manage',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
          },
          BODY: {
            LABEL: {
              PERMISSION: 'Permission',
              VIEW: 'View',
              CREATE: 'Create',
              UPDATE: 'Update',
              DELETE: 'Delete',
              UPLOAD: 'Upload',
              DOWNLOAD: 'Download',
            },
          },
        },
        INPUT: {
          NAME: {
            LABEL: 'Name',
            PLACEHOLDER: 'Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'Select your option',
            ALL: 'All',
          },
          SHOW_ENTRY: {
            LABEL: 'Show Entry',
            PLACEHOLDER: 'Show Entry',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          NAME: {
            LABEL: 'Name',
            PLACEHOLDER: 'Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          OPTION: {
            LABEL: 'Option',
            PLACEHOLDER: 'Select your option',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },

        BUTTON: {
          SEARCH: 'Search',
          ADD: 'Add',
          CLOSE: 'Close',
          SAVE: 'Save',
          EDIT: 'Edit',
          CANCEL: 'Cancel',
          OK: 'Ok',
        },
      },
      PLAN_WATER_DRY_SEASON: {
        MIDDLE_RESERVIOR_MANAGE: {
          HEADER: {
            ADD: 'Add Plan Water',
            EDIT: 'Edit Plan Water Dry Season',
          },
        },
        APPROVAL: {
          TITLE: 'Water Allocation Plans Pending Approval',
          APPROVE_TYPE: {
            MAJOR_RESERVOIR: 'Large Reservoirs',
            OTHER_MAJOR: 'Large Irrigation Offices',
            MEDIUM_RESERVOIR: 'Medium Reservoirs',
            OTHER_MEDIUM_RESERVOIR: 'Other Medium Reservoirs',
            OTHER_WATER_SOURCE: 'Weirs, Floodgates, and Other Water',
            NATURAL_WATER: 'Natural Water Sources',
            MAEKLONG: 'Mae Klong River Basin',
            CHAOPHRAYA: 'Chao Phraya River Basin',
          },
          BUTTON: {
            BACK: 'Turn back',
            APPROVE: 'Approve',
            NOT_APPROVE: 'Reject',
          },
          POPUP: {
            APPROVE: {
              TITLE: 'save',
              MESSAGE: 'Do you confirm the approval ?',
            },
            REJECT: {
              TITLE: 'บันทึก',
              MESSAGE: 'Do you confirm the reject ?',
            },
          },
        },
        LARGE_RESERVOIR: {
          TITLE: 'Water Allocation Plan Large-Scale Reservoirs',
          TAB_1: 'Water Allocation Plan Large Reservoirs',
          TAB_2: 'Plan By Project',
          MANAGE: {
            HEADER:
              'Update Data on the Water Allocation Plan for Large-Scale Reservoir Project',
          },
        },
        LARGE_PROJECT: {
          TITLE: 'Large-Scale Reservoir Project',
        },
        TAB_PLAN: {
          DAILY: 'Daily Water Plan',
          WEEKLY: 'Weekly Water Plan',
        },
        OTHER_LARGE_RESERVOIR: {
          TITLE: 'Water Allocation Plan for Large-Scale Irrigation Offices',
          BUTTON: {
            ADD_PROJECT: 'Create Project',
          },
        },
        OTHER_LARGE_PROJECT: {
          TITLE: 'Large-Scale Irrigation Offices',
          MANAGE: {
            ADD: 'Create Project',
            TURN_BACK: 'Back to Water Allocation',
          },
        },
        MEDIUM_RESERVOIR: {
          TITLE: 'Water Allocation Plan from 435 Medium-Scale Reservoirs',
          TAB_1: 'Water Allocation Plan Medium Reservoirs',
          TAB_2: 'Plan By Project',
          MANAGE: {
            HEADER:
              'Update Data on the Water Allocation Plan for Medium-Scale Reservoir Project',
          },
        },
        MEDIUM_PROJECT: {
          TITLE: 'Medium-Scale Reservoir Project',
        },
        OTHER_MEDIUM: {
          TITLE: 'Water Allocation Plan for Remaining Medium-Scale Reservoirs',
        },
        OTHER_MEDIUM_PROJECT: {
          TITLE: 'Medium-Scale Irrigation Offices',
          BUTTON: { TURN_BACK: 'Back to Water Allocation' },
        },
        OTHER_WATER: {
          TITLE:
            'Water Allocation Plan from Weirs, Floodgates, and Other Water',
          BUTTON: {
            ADD: 'Create Water Source',
            TURN_BACK: 'Back to Water Allocation',
          },
        },
        OTHER_WATER_PROJECT: {
          TITLE: 'Other Water Source Irrigation Offices',
          BUTTON: { TURN_BACK: 'Back to Water Allocation' },
        },
        NATURAL_WATER: {
          TITLE: 'Water Allocation Plan for Natural Water Sources',
        },
        NATURAL_WATER_PROJECT: {
          TITLE: 'Natural Water Sources Irrigation Offices',
          BUTTON: { TURN_BACK: 'Back to Water Allocation' },
        },
        MAEKLONG: {
          TITLE: 'Mae Klong Basin Daily/Weekly Water Allocation Plan',
          HEADER: {
            DAILY: 'Daily Water Allocation Plan for Mae Klong Basin (MCM)',
            WEEKLY: 'Weekly Water Allocation Plan for Mae Klong Basin (MCM)',
            MONTHLY: 'Monthly Water Demand for Mae Klong Basin',
          },
          MANAGE: {
            HEADER_DAILY: 'Import Daily Plan for Mae Klong Basin',
            HEADER_WEEKLY: 'Create a Weekly Plan for Mae Klong Basin',
          },
        },
        MAEKLONG_PROJECT_PLAN: {
          TITLE:
            'Project-based Water Allocation Plan in the Mae Klong River Basins',
        },
        MAEKLONG_PROJECT: {
          TITLE: 'Mae Klong Basin Irrigation Offices',
          BUTTON: { TURN_BACK: 'Back to Water Allocation' },
        },
        CHAOPHRAYA_DAM: {
          TITLE: 'Daily/weekly water allocation for 4 Chao Phraya Dams',
          HEADER: {
            DAILY:
              'Daily Water Allocation Plan for Chao Phraya River Basin (MCM)',
            WEEKLY:
              'Weekly Water Allocation Plan for Chao Phraya River Basin (MCM)',
            MONTHLY: 'Monthly Water Demand for Chao Phraya River Basin',
          },
          MANAGE: {
            HEADER_DAILY: 'Import Daily Plan for Chao Phraya River Basin',
            HEADER_WEEKLY: 'Create a Weekly Plan for Chao Phraya River Basin',
          },
        },
        CHAOPHRAYA_PLAN: {
          TITLE: 'Chao Phraya Basin Daily/Weekly Water Allocation Plan',
          TAB: {
            TAB_1:
              'Weekly Water Allocation Plan for the Chao Phraya Basin at the Canal Level',
            TAB_2: 'Weekly Water Plan',
            TAB_3: 'RIO. 3',
            TAB_4: 'RIO. 4',
            TAB_5: 'RIO. 10',
            TAB_6: 'RIO. 11',
            TAB_7: 'RIO. 12',
          },
          TABLE_20: {
            HEADER: {
              UPSTREM_CHAOPHRAYA: 'Upstream ChaoPhraya',
              PUMPING: 'Electric Water Pump',
              TDD_WB: 'TddWbWy-Nt',
              NAKHONSAWAN: 'NakhonSawan',
              KHUNDAN: 'KhunDan',
              YOMNAN: 'YomNan',
              UNIT: 'Phlai Chumphon,Dong Setthi,Thabua',
              KWANNOI: 'Khwae Noi River',
              THACHIN: 'ThaChin River',
              NOI_RIVER: 'Noi River',
              ROI_12: 'RIO. 12',
              ROI_11: 'RIO. 11',
              ROI_1011: 'RIO.10-11',
              SUM_ROI_1011: 'Total (ROI.10-11)',
              PSU_CANAL: 'Makham Thao,U Thong Canal',
              SMALL_CANAL: 'Small Canal',
              SUM_1211: 'Total (ROI.12-11)',
              ROI_1211: 'ROI.12-11',
              MANOROM: 'Manorom',
              MAHARAT: 'Maharat',
              SUM_101112: 'Total ROI.10,11 and 12',
              DOWNSTREM: 'ChaoPhraya Dam Downstream',
              SIRIKIT: 'Total Water Demand BhumibolSirikit',
              DEMAND_KWANNOI: 'Water Demand Khwae Noi',
              DEMAND_PASAK: 'Water Demand PaSak',
              MAEKLONG: 'Water Diversion MaeKlong Basin',
              TOTAL_DEMAND: 'Total Water Demand',
            },
          },
          TABLE_19: {
            HEADER: {
              DEMAND_SIRIKIT: 'Total Water Demand BhumibolSirikit',
              UPSTREM_CHAOPHRAYA: 'Water Demand Upstream ChaoPhraya',
              PUMPING: 'Electric Water Pump',
              CATCHMENT: 'Catchment area',
              TDD_WB: 'TddWbWy-Nt',
              NAKHONSAWAN: 'NakhonSawan',
              KHUNDAN: 'Naresuan Dam',
              YOMNAN: 'YomNan',
              UNIT: 'Phlai Chumphon,Dong Setthi,Thabua',
              KWANNOI: 'Khwae Noi River',
              WESTERN: 'Western Field (RIO.12,11)',
              EASTERN: 'Eastern Field (RIO.10,11)',
              DOWNSTREM_CHAOPHRAYA: 'ChaoPhraya Dam Downstream',
              DEMAND_KWANNOI: 'Water Demand Khwae Noi',
              DEMAND_PASAK: 'Total Water Demand BhumibolSirikit',
              RAMAVI: 'Total Water Demand RamaVI',
              PHOPHRAYA: 'Downstream Plan PhoPhraya',
              MAEKLONG: 'Water Diversion MaeKlong Basin',
              EASTERN_FOODPLAIN: 'Eastern Floodplain Water',
              ROI_10: 'RIO.10',
              ROI_11: 'RIO.11',
            },
          },
        },

        CHAOPHRAYA_PROJECT_PLAN: {
          TITLE:
            'Project-based Water Allocation Plan for the Chao Phraya River Basin',
          HEADER: {
            WATER: 'Allocable water volume : {{value}} Million cubic meters',
          },
        },
        CHAOPHRAYA_FLOW: {
          TITLE: 'Water Allocation Diagram For the Chao Phraya River Basin.',
          SUB_TITLE: '(Unit : MCM.)',
          HEADER: {
            BHUMIBOL: 'Released water from Bhumibol and Sirikit dam',
            KWAENOI: 'Released water from KwaeNoi',
            UPSTREM_CHAOPHRAYA: 'Water Use from Upstream ChaoPhraya',
            WESTERN: 'Water Use from Western Field',
            EASTERN: 'Water Use from Eastern Field',
            UPPER_FIELD: 'Upper Field',
            UPPER_LOWER: 'Upper And Lower Field',
            MAEKLONG: 'Water Diversion Mae Klong Basin',
            PASAK: 'Released water from Pasak Chonlasit Dam',
            LOWER_FOODPLAIN: 'Lower Field',
            MWA: 'Metropolitan Waterworks Authority',
            THACHIN:
              'Protect the ecosystem and prevent saltwater intrusion at the mouth of the Tha Chin River',
            CHAOPHRAYA:
              'Protect the ecosystem and prevent saltwater intrusion at the mouth of ChaoPhraya River',
            NAKHONSAWAN: 'NakhonSawan',
            CHAOPHRAYA_DAM: 'ChaoPhraya Dam',
            RIO_12: 'Total RIO. 12',
            RIO_10: 'Total RIO. 10',
            RIO_11: 'Total RIO. 11',
            PHOPHRAYA: 'PhoPhraya Gate',
            PHOKHOI: 'PhoKhoi Gate',
            PHAKHAICHAOCHET: 'PhakHaiChaoChet Gate',
            RAMA_VI: 'RamaIV Dam',
            PHRASRISIN: 'Phrasrisin Gate',
            PHRASRISAOWAPHAK: 'Phrasrisaowaphak Gate',
            PHRAYABUNLUE: 'Phrayabunlue Gate',
            SINGHANAT: 'Singhanat2 Pumping Station',
          },
        },
        CHAOPHRAYA_PROJECT: {
          TITLE: 'Chao Phraya River Basin Irrigation Offices',
          BUTTON: { TURN_BACK: 'Back to Water Allocation' },
          INPUT: {
            SEARCH: {
              LABEL: 'Search',
              PLACEHOLDER: 'Search project name',
            },
          },
        },
        POPUP: {
          DAILY: {
            HEADER: 'Import Daily Water Allocation',
          },
          WEEKLY: {
            HEADER: 'Create a Weekly Water Allocation Plan',
          },
          MONTHLY: {
            HEADER: 'Monthly Water Demand',
          },
        },
      },
      ACTIVITY: {
        TITLE: 'Activity',
        TABLE: {
          HEADER: {
            SEQUENCE: 'Sequence',
            NAME: 'Activity Name',
            MANAGE: 'Manage',
            UPDATE_DATE: 'Update Date',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
          },
        },
        INPUT: {
          SEARCH: {
            LABEL: 'Search',
            PLACEHOLDER: 'Search',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          NAME: {
            LABEL: 'Activity Name',
            PLACEHOLDER: 'Search',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          ORDER: {
            LABEL: 'Display Order',
            PLACEHOLDER: 'Display Order',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'Select your option',
            ALL: 'All',
          },

          SHOW_ENTRY: {
            LABEL: 'Show Entry',
            PLACEHOLDER: 'Show Entry',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },

        BUTTON: {
          SEARCH: 'Search',
          ADD: 'Add',
          CLOSE: 'Close',
          SAVE: 'Save',
          EDIT: 'Edit',
          CANCEL: 'Cancel',
          OK: 'Ok',
        },
      },
      RIVERBASIN: {
        TITLE: 'Riverbasin',
        TABLE: {
          HEADER: {
            SEQUENCE: 'Sequence',
            CODE: 'Code',
            NAME: 'Name',
            UPDATE_DATE: 'Update Date',
            MANAGE: 'Manage',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
          },
        },

        INPUT: {
          NAME: {
            LABEL: 'Name',
            PLACEHOLDER: 'Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          AREA: {
            LABEL: 'Area',
            PLACEHOLDER: 'Area',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          CODE: {
            LABEL: 'Code',
            PLACEHOLDER: 'Code',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          GEOMETRY: {
            LABEL:
              'Upload complete — click "Upload Shape File" to make changes.',
            PLACEHOLDER: '',
          },
          FILE: {
            LABEL: 'Upload Shape File (.shx, .shp, .prj, .dbf, .cpg)',
            PLACEHOLDER: '',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },
      },
      SUBBASIN: {
        TITLE: 'Sub Basin',
        TABLE: {
          HEADER: {
            SEQUENCE: 'Sequence',
            NAME: 'Name',
            UPDATE_DATE: 'Update Date',
            MANAGE: 'Manage',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
          },
        },
        INPUT: {
          NAME: {
            LABEL: 'Name',
            PLACEHOLDER: 'Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },
      },
      PLANT: {
        TITLE: 'Plant',
        TABLE: {
          HEADER: {
            SEQUENCE: 'Sequence',
            NAME: 'Plant Name',
            UPDATE_DATE: 'Update Date',
            MANAGE: 'Manage',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
          },
        },
        INPUT: {
          SEARCH: {
            LABEL: 'Search',
            PLACEHOLDER: 'Search',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          NAME: {
            LABEL: 'Plant Name',
            PLACEHOLDER: 'Activity Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          ORDER: {
            LABEL: 'Display Order',
            PLACEHOLDER: 'Display Order',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'Select your option',
            ALL: 'All',
          },

          SHOW_ENTRY: {
            LABEL: 'Show Entry',
            PLACEHOLDER: 'Show Entry',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },

        BUTTON: {
          SEARCH: 'Search',
          ADD: 'Add',
          CLOSE: 'Close',
          SAVE: 'Save',
          EDIT: 'Edit',
          CANCEL: 'Cancel',
          OK: 'Ok',
        },
      },
      NATURAL_WATER: {
        TITLE: 'Natural Water Sources',
        TABLE: {
          HEADER: {
            SEQUENCE: 'Sequence',
            FULL_NAME: ' Name',
            UPDATE_DATE: 'Update Date',
            MANAGE: 'Manage',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
          },
        },
        INPUT: {
          SEARCH: {
            LABEL: 'Search',
            PLACEHOLDER: 'Search',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          NAME: {
            LABEL: 'Name',
            PLACEHOLDER: 'Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'Select your option',
            ALL: 'All',
          },
          FULL_NAME: {
            LABEL: 'Full Name',
            PLACEHOLDER: 'Full Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },

          SHOW_ENTRY: {
            LABEL: 'Show Entry',
            PLACEHOLDER: 'Show Entry',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },

        BUTTON: {
          SEARCH: 'Search',
          ADD: 'Add',
          CLOSE: 'Close',
          SAVE: 'Save',
          EDIT: 'Edit',
          CANCEL: 'Cancel',
          OK: 'Ok',
        },
      },
      OTHER_MIDDLE_RESERVOIR: {
        TITLE: 'Other Middle Reservoir',
        NAV: {
          RESERVOIR_LARGE_SIZE: 'Reservoir Large Size',
          RESERVOIR_MIDDLE_SIZE: 'Reservoir Middle Size',
        },
        TABLE: {
          HEADER: {
            SEQUENCE: 'Sequence',
            RESERVOIR: 'Reservoir',
            RESPONSIBLE_PROJECTS: 'Responsible Projects',
            IRRIGATION_DEPARTMENT: 'Irrigation Department',
            PROVINCE: 'Province',
            MAIN_BASIN: 'Main Basin',
            SUB_BASIN: 'Sub Basin',
            MANAGE: 'Manage',
          },
          INPUT: {
            RESERVOIR_NAME: {
              LABEL: 'Reservoir Name',
              PLACEHOLDER: 'Search',
            },
          },
        },
        MANAGE: {
          HEADER: {
            ADD_RESERVOIR: 'Add Reservoir',
            EDIT_RESERVOIR: 'Edit Reservoir',
          },
          LABEL: {
            CAPACITY_WATER: 'Capacity Water',
            CAPACITY_LEVEL: 'Capacity Level',
            WATER_LEVEL: 'Water Level',
          },
        },
        INPUT: {
          RESERVOIR_NAME: {
            LABEL: 'Reservoir',
            PLACEHOLDER: 'Reservoir',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },

          LATITUDE: {
            LABEL: 'Latitude',
            PLACEHOLDER: 'Latitude',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          LONGITUDE: {
            LABEL: 'Longitude',
            PLACEHOLDER: 'Longitude',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'Select your option',
            ALL: 'All',
          },
          IRRIGATION_DEPARTMENT: {
            LABEL: 'Responsible Projects',
            PLACEHOLDER: 'Responsible Projects',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },

          PROJECT: {
            LABEL: 'Project',
            PLACEHOLDER: 'Project',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          RESERVOIR: {
            LABEL: 'Reservoir',
            PLACEHOLDER: 'Reservoir',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          SHOW_ENTRY: {
            LABEL: 'Show Entry',
            PLACEHOLDER: 'Show Entry',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          RESERVOIR_SIZE: {
            LABEL: 'Reservoir Size',
            PLACEHOLDER: 'Reservoir Size',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          PROVINCE: {
            LABEL: 'Province',
            PLACEHOLDER: 'Province',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          DISTRICT: {
            LABEL: 'District',
            PLACEHOLDER: 'District',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          SUB_DISTRICT: {
            LABEL: 'Sub District',
            PLACEHOLDER: 'Sub District',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          MAIN_BASIN: {
            LABEL: 'Main Basin',
            PLACEHOLDER: 'Main Basin',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          SUB_BASIN: {
            LABEL: 'Sub Basin',
            PLACEHOLDER: 'Sub Basin',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },

        BUTTON: {
          SEARCH: 'Search',
          ADD_RESERVOIR: 'Add Reservoir',
          CLOSE: 'Close',
          SAVE: 'Save',
          EDIT: 'Edit',
          CANCEL: 'Cancel',
          OK: 'Ok',
        },
      },
      OTHER_WATER_SOURCE: {
        TITLE: 'Other Water Sources',
        TABLE: {
          HEADER: {
            SEQUENCE: 'Sequence',
            NAME: ' Name',
            WATER_TYPE: 'Water Source Type',
            PROVINCE: 'Province',
            MAIN_BASIN: 'Main Basin',
            SUB_BASIN: 'Sub Basin',
            UPDATE_DATE: 'Update Date',
            MANAGE: 'Manage',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
          },
        },
        INPUT: {
          SEARCH: {
            LABEL: 'Search',
            PLACEHOLDER: 'Search',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          NAME: {
            LABEL: 'Name',
            PLACEHOLDER: 'Name',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'Select your option',
            ALL: 'All',
          },
          WATER_TYPE: {
            LABEL: 'Water Sources Type',
            PLACEHOLDER: 'Water Sources Type',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
          SHOW_ENTRY: {
            LABEL: 'Show Entry',
            PLACEHOLDER: 'Show Entry',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },

        BUTTON: {
          SEARCH: 'Search',
          ADD: 'Add',
          CLOSE: 'Close',
          SAVE: 'Save',
          EDIT: 'Edit',
          CANCEL: 'Cancel',
          OK: 'Ok',
        },
      },
      MENU: {
        TITLE: 'Menu Tips',
        MANAGE: {
          ADD: 'Add',
          EDIT: 'Edit',
          DELETE: 'Delete',
          MESSAGE_ENABLE: 'Do you want to enable tips ?',
          MESSAGE_DISABLE: 'Do you want to disable tips ?',
        },
      },
      SUMMARY: {
        TAB: {
          PROJECT: {
            NAME: 'Project',
            TITLE: 'Summary of Dry Season Water Allocation Plan by Project',
          },
          PROVINCE: {
            NAME: 'Project By Province',
            TITLE: 'Summary of Dry Season Water Allocation Plan by Province',
            REMARK_1: {
              NAME: 'Remark',
              LABEL:
                'Water volume and irrigated area data will display totals only for entries with the status “Under Consideration.” (Click the project name to view details.)',
            },
            REMARK_2: {
              NAME: 'Remark',
              LABEL:
                'Water volume and irrigated area data will display totals only for entries with the status “Under Consideration.”',
            },
          },
          STATUS: {
            NAME: 'Dry Season Water Allocation Plan Status Tracking',
            TITLE_LARGE_RESERVOIR:
              'Water Allocation Plan for Large-Scale Reservoirs',
            TITLE_OTHER_LARGE:
              'Water Allocation Plan for Large-Scale Irrigation Offices',
            TITLE_MEDIUM_RESERVOIR:
              ' Water Allocation Plan from 435 Medium-Scale Reservoirs',
            TITLE_OTHER_MEDIUM:
              ' Water Allocation Plan for Remaining Medium-Scale Reservoirs',
            TITLE_OTHER_WATER:
              'Water Allocation Plan from Weirs, Floodgates, and Other Water Control Structures',
            TITLE_NATURAL_WATER:
              'Water Allocation Plan from Natural Water Sources',
            TITLE_MAEKLONG: 'Water Allocation Plan from Mae Klong Basin',
            TITLE_CHAOPHRAYA: 'Water Allocation Plan from  Chao Phraya Basin',
          },
        },
        TABLE: {
          HEADER: {
            YEAR: 'Year',
            IRRIGATION_DEPARTMENT: 'Irrigation',
            PROJECTS: 'Project',
            PROVINCE: 'Province',
            AREA: 'Area (Rai)',
            WATER_VOLUME_1NOV: 'Water Volume as of 1 Nov',
            FORECASTED: 'Forecast of Available Base Water',
            CURRENT_WATER: 'Current Water Volume',
            WATER_VOLUME: 'Water Volume (MCM)',
            AREA_IRRIGATION: 'Area of irrigation',
            WATER_PERIOD: 'Water Delivery Period',
            TOTAL: 'Total',
            START_DATE: 'Start',
            END_DATE: 'End',
            RESERVOIR_OTHER: 'Reservoirs / Other water sources',
            MENU: 'Menu',
            STATUS: 'Status',
            FILE: 'Attachment',
          },
        },
        INPUT: {
          AREA: {
            LABEL: 'Area',
            PLACEHOLDER: 'Please specify area',
            VALIDATE: {
              REQUIRED: 'This field is required.',
            },
          },
        },
        BUTTON: {
          SEARCH: 'Search',
          DOWNLOAD: 'Download',
        },
      },
    },
  },
};
